import React, { useEffect } from "react";
import { UtilsUser } from "../../utils/UtilsUser";
import DigitalLegacyAuth from "../../pages/nonauth/DigitalLegacyAuth/DigitalLegacyAuth";
import { ApplicationState } from "../../store";
import { UserState } from "../../store/reducers/user-reducer";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { AUTHENTICATED_ROUTES} from "../../configs/routes";
import { URLS } from "../../constants/urls";
import { SPDL_TICKET_NUMBER } from "../../constants/ticketNumberRegex";

interface Props {
  children?: React.ReactNode;
}

const DeepLinkChecker: React.FC<Props> = (props) => {
  const { pathname } = useLocation();

  const currentURL = window.location.pathname;
  const reqNum = currentURL.split("/").pop();
  const isDLRequestDeepLink = reqNum?.match(SPDL_TICKET_NUMBER);
  const isUserSignedOut = !UtilsUser.isUserLoggedIn();

  const { userCountryCode } = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );

  // IF UserCountryCode is 'CN' automatically redirect USER to CHINA LOCALSITE
  const handleLocalsiteRedirectionForCN = () => {
    const isAuthRoute = AUTHENTICATED_ROUTES.includes(pathname);
    const isChinaCountryCode = userCountryCode === "CN";

    if (isAuthRoute && isUserSignedOut && isChinaCountryCode)
      window.location.replace(URLS.CHINA_LOCALSITE);
  };

  useEffect(() => {
    handleLocalsiteRedirectionForCN();
  }, [pathname, userCountryCode]);

  // IF DEEPLINK is Digital Legacy and user is not yet LOGGED IN, REDIRECT to DL REDIRECT PAGE
  if (isDLRequestDeepLink && !UtilsUser.isUserLoggedIn()) {
    return <DigitalLegacyAuth />;
  }
  // IF NORMAL DEEPLINK: RETURN CHILDREN COMPONENTS 
  return (<>{props.children}</>)
};

export default DeepLinkChecker;
